/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

import { useAuthUser } from '@/rest/hooks/use-auth/use-auth-user';

/**
 * A very simple hook that accepts an user id that *should* come from a server component
 * signaling that *something* was hydrated or cached using the currently logged in user.
 * This hook can be used to wait until the auth provider has finished initializing so that
 * downstream components don't render with the user id (from the auth provider) being null.
 *
 * WARNING: This should only be used with pages/components that with both logged in users
 * and being unauthenticated. If you need to protect a page, use the AuthGuard component
 * instead.
 */
export function useWaitForAuth(hydratedWithUserId: string | null): boolean {
  const { status: authStatus } = useAuthUser();

  return hydratedWithUserId != null && authStatus === 'initializing';
}
